/**
 * Scroll-Choreografie und Daumenleiste.
 *
 * Zwei Aufgaben, ein Beobachtermuster, deshalb eine Datei:
 *
 * 1. Gestaffelte Reveals. Alles mit [data-ff-reveal] steht zunächst
 *    verschoben und durchsichtig und kommt beim Erscheinen im Sichtfeld
 *    an seinen Platz. Die Staffelung liegt als --i im Markup.
 * 2. Die Sticky-Daumenleiste. Sie ist sichtbar, sobald der Warenkorb-
 *    knopf nicht im Sichtfeld ist, und verschwindet, sobald man beim
 *    Kaufmodul angekommen ist. Zwei gleichzeitige Kaufknöpfe gibt es
 *    damit nie.
 *
 * Drei Regeln:
 * - Ohne dieses Skript steht alles im Endzustand. Die Klasse ff-js wird
 *   hier gesetzt, nicht im HTML, damit eine ausgefallene Datei nichts
 *   unsichtbar hängen lässt.
 * - prefers-reduced-motion schaltet die Choreografie ganz ab. Wer
 *   Bewegung abbestellt hat, sieht dieselbe Seite, nur fertig.
 * - Kein Fremdabruf, keine Bibliothek. IntersectionObserver reicht.
 */
(function () {
  'use strict';

  var ruhe = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Reveals ---------- */
  function revealsStarten() {
    var stuecke = document.querySelectorAll('[data-ff-reveal]');
    if (!stuecke.length) return;

    /* Ohne Beobachter oder mit abbestellter Bewegung: sofort fertig. */
    if (ruhe || !('IntersectionObserver' in window)) {
      for (var i = 0; i < stuecke.length; i++) {
        stuecke[i].setAttribute('data-sichtbar', 'ja');
      }
      return;
    }

    document.documentElement.classList.add('ff-js');

    var beobachter = new IntersectionObserver(
      function (treffer) {
        treffer.forEach(function (eintrag) {
          if (!eintrag.isIntersecting) return;
          eintrag.target.setAttribute('data-sichtbar', 'ja');
          beobachter.unobserve(eintrag.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.05 }
    );

    for (var k = 0; k < stuecke.length; k++) {
      beobachter.observe(stuecke[k]);
    }
  }

  /* ---------- 2. Die Daumenleiste ----------
     Der Anker ist der echte Warenkorbknopf, nicht eine Bildschirmhöhe:
     nur so kann die Leiste nie gleichzeitig mit ihm sichtbar sein.

     Seit dem 27.10.2026 (Prüfstab 2, N6, und Prüfstab 5, B5) zählt auch
     das Kaufmodul selbst: steht es in der oberen Hälfte des Bildschirms,
     ist der Kunde angekommen, und die Leiste geht weg. Bis dahin blieb sie
     im ganzen Formular stehen, bis der Kaufknopf im Bild war, und
     verdeckte unten rund 90 px der Felder. Ein Tippen auf "Jetzt
     gestalten" setzt außerdem den Fokus auf das Kaufmodul (tabindex -1),
     sonst blieb er auf body und die nächste Tabulatortaste begann oben
     auf der Seite. */
  function daumenStarten() {
    var leiste = document.querySelector('[data-ff-daumen]');
    if (!leiste) return;

    var ziel = document.getElementById(leiste.getAttribute('aria-controls') || '');
    var knopf = ziel ? ziel.querySelector('[data-ff-kaufknopf]') || ziel : null;

    if (ziel) {
      var sprung = leiste.querySelector('a[href="#' + ziel.id + '"]');
      if (sprung) {
        sprung.addEventListener('click', function () {
          if (!ziel.hasAttribute('tabindex')) ziel.setAttribute('tabindex', '-1');
          leiste.setAttribute('data-an', 'nein');
          /* Erst nach dem Sprung des Ankers, damit focus() nicht selbst scrollt. */
          window.setTimeout(function () {
            try {
              ziel.focus({ preventScroll: true });
            } catch (fehler) {
              ziel.focus();
            }
          }, 0);
        });
      }
    }

    if (!knopf || !('IntersectionObserver' in window)) {
      /* Ohne Anker bleibt die Leiste stehen. Ein fehlender Kaufknopf
         ist kein Grund, den einzigen mobilen Kaufweg zu verstecken. */
      leiste.setAttribute('data-an', 'ja');
      return;
    }

    var imBild = { knopf: false, modul: false };
    function setzen() {
      leiste.setAttribute('data-an', imBild.knopf || imBild.modul ? 'nein' : 'ja');
    }

    var wache = new IntersectionObserver(
      function (treffer) {
        treffer.forEach(function (eintrag) {
          imBild.knopf = eintrag.isIntersecting;
        });
        setzen();
      },
      { threshold: 0 }
    );
    wache.observe(knopf);

    if (ziel && ziel !== knopf) {
      var modulWache = new IntersectionObserver(
        function (treffer) {
          treffer.forEach(function (eintrag) {
            imBild.modul = eintrag.isIntersecting;
          });
          setzen();
        },
        { rootMargin: '0px 0px -50% 0px', threshold: 0 }
      );
      modulWache.observe(ziel);
    }
  }

  function los() {
    revealsStarten();
    daumenStarten();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', los);
  } else {
    los();
  }
})();
